

let serviceList = [
  {
    title: "Air Ticketing",
    des: "Best Deals on Domestic & International Flights",
    img: "assets/img/s-1.png",
    link:"/AirTicketing",
  },
  {
    title: "Travel Insurance",
    des: "Secure Your Journey with Comprehensive Travel Insurance",
    img: "assets/img/s-2.png",
    link:"/TravelInsurance",
  },
  {
    title: "Domestic & International Tours",
    des: "Explore India & the World with Customized Tour Packages",
    img: "assets/img/s-3.png",
    link:"/DomesticInternationalTours",
  },
  {
    title: "MICE ",
    des: "Professional Corporate Travel Management",
    img: "assets/img/s-4.png",
    link:"/MICE",
  },
  {
    title: "Passport & Visa Assistance",
    des: "Smooth & Hassle-Free Passport and Visa Services",
    img: "assets/img/s-5.png",
    link:"/PassportVisa",
  },

  {
    title: "Hotel Booking",
    des: "Best Hotel Deals - From Budget to Luxury",
    img: "assets/img/s-6.png",
    link:"/HotelBooking",
  },
];

export default serviceList;
